// import React, { Component } from "react";
// import { calculatePrice } from "../../pricing/calculatePrice";
// import Axios from "axios";
// import { connect } from "react-redux";
// import { configuration } from "../../appConfig";
// import Swal from "sweetalert2";
// const Toast = Swal.mixin({
//   toast: true,
//   position: "top-end",
//   showConfirmButton: false,
//   timer: 3000,
// });

// class RomaniaPriceTable extends Component {
//   state = {
//     data: [],
//     Dents: [],
//     words: {},
//     lang: "En",
//     swissTableSL: [],
//     selected: {
//       Hood: false,
//       LeftFrontFender: false,
//       LeftFrontDoor: false,
//       LeftBackDoor: false,
//       LeftBackFender: false,
//       Trunk: false,
//       TrunkCover: false,
//       RightBackFender: false,
//       RightBackDoor: false,
//       RightFrontDoor: false,
//       RightFrontFender: false,
//       Roof: false,
//       LeftRoofFrame: false,
//       RightRoofFrame: false,

//       ALUPercentage: "",
//       LAKPercentage: "",
//     },
//   };
//   count = [];
//   calPrice = (average, count) => {
//     let pp = calculatePrice(average, count);
//     //this.count.push(pp)
//     return (pp * 130) / 6;
//   };
//   calUnit = (average, count) => {
//     let pp = calculatePrice(average, count);
//     this.count.push(pp);
//     return pp;
//   };

//   getJsonApi = () => {
//     const partnerId = localStorage.getItem("partnerId");
//     const vin = localStorage.getItem("selectedFile");
//     Axios.get(
//       `${configuration.getData}?vin=${vin}&partnerId=${partnerId}`
//     ).then((r) => {
//       if (r.data) {
//         // r.data.Dents
//         let indexToMerge = 5;

//         r.data.Dents[indexToMerge].A += r.data.Dents[indexToMerge + 1].A;
//         r.data.Dents[indexToMerge].B += r.data.Dents[indexToMerge + 1].B;
//         r.data.Dents[indexToMerge].C += r.data.Dents[indexToMerge + 1].C;
//         r.data.Dents[indexToMerge].TotalDents +=
//           r.data.Dents[indexToMerge + 1].TotalDents;
//         r.data.Dents[indexToMerge].AW += r.data.Dents[indexToMerge + 1].AW;
//         r.data.Dents[indexToMerge].AW_original +=
//           r.data.Dents[indexToMerge + 1].AW_original;

//         if (!r.data.Dents[indexToMerge].Alu) {
//           r.data.Dents[indexToMerge].Alu = r.data.Dents[indexToMerge + 1].Alu;
//         }
//         if (!r.data.Dents[indexToMerge].Push2paint) {
//           r.data.Dents[indexToMerge].Push2paint =
//             r.data.Dents[indexToMerge + 1].Push2paint;
//         }
//         if (!r.data.Dents[indexToMerge].Replace) {
//           r.data.Dents[indexToMerge].Replace =
//             r.data.Dents[indexToMerge + 1].Replace;
//         }

//         r.data.Dents.splice(indexToMerge + 1, 1);
//         this.setState({ data: r.data, Dents: r.data.Dents });
//       }
//     });
//   };
//   componentDidMount() {
//     this.getLang();
//     this.getJsonApi();
//     this.getFallbackDetails();
//   }

//   getFallbackDetails = async () => {
//     const url =
//       configuration.getFallbackDetails +
//       `?partner_id=${localStorage.getItem("partnerId")}`;
//     const res = await Axios.get(url);

//     if (res.data.success !== false) {
//       this.setState({
//         ALUPercentage: res.data.alu,
//         LAKPercentage: res.data.lak,
//       });
//     }
//   };

//   getLang = () => {
//     const base_url = window.location.origin;
// Axios.get(`${base_url}/lang.json`).then((res) => {
//       this.setState({ words: res.data, lang: localStorage.getItem("lang") });
//     });
//   };
//   lang = (word) => {
//     const { lang, words } = this.state;
//     return words[word] ? words[word][lang] : word;
//   };
//   static getDerivedStateFromProps(nextProps, prevState) {
//     //alert(nextProps.lang+"123")
//     if (nextProps.lang !== prevState.lang) {
//       return { lang: nextProps.lang };
//     } else return null;
//   }
//   saveChanges = (payload, totalDents) => {
//     const url =
//       configuration.PostEditorChanges +
//       `?partnerId=${localStorage.getItem(
//         "partnerId"
//       )}&vin=${localStorage.getItem("selectedFile")}&dents=${totalDents}`;

//     Axios.post(url, payload).then((res) => {
//       Toast.fire({
//         type: "success",
//         title: "Data saved successfully",
//       });
//       // window.location.reload();
//     });
//   };
//   // change = (part, e, index, key) => {
//   //   const { Dents, data } = this.state;
//   //   const totalDents = Dents[index].TotalDents;
//   //   Dents[index][key] = e.target.checked;
//   //   this.setState({ data });
//   //   this.saveChanges(data, totalDents);
//   // };

//   change = (part, e, index, key) => {
//     const { Dents, data } = this.state;
//     const totalDents = Dents[index].TotalDents;

//     if (key === "Replace") {
//       if (Dents[index][key]) {
//         Dents[index]["AW"] = Dents[index]["AW_original"] || 0;
//       } else {
//         Dents[index]["Alu"] = false;
//         Dents[index]["Push2paint"] = false;
//         Dents[index]["AW"] = 0;
//       }
//     } else {
//       if (Dents[index]["Replace"]) {
//         Dents[index]["Replace"] = false;
//         Dents[index]["AW"] = Dents[index]["AW_original"] || 0;
//       }
//       if (!Dents[index][key]) {
//         if (key === "Alu" && this.state.ALUPercentage) {
//           Dents[index]["AW"] = Math.ceil(
//             parseFloat(Dents[index]["AW"]) +
//               (parseFloat(Dents[index]["AW"]) * this.state.ALUPercentage) /
//                 100.0
//           );
//         } else if (key === "Push2paint" && this.state.LAKPercentage) {
//           Dents[index]["AW"] = Math.ceil(
//             parseFloat(Dents[index]["AW"]) +
//               (parseFloat(Dents[index]["AW"]) * this.state.LAKPercentage) /
//                 100.0
//           );
//         }
//       } else {
//         if (key === "Alu" && this.state.ALUPercentage) {
//           Dents[index]["AW"] = Math.floor(
//             parseFloat(Dents[index]["AW"]) -
//               (parseFloat(Dents[index]["AW"]) * this.state.ALUPercentage) /
//                 100.0
//           );
//         } else if (key === "Push2paint" && this.state.LAKPercentage) {
//           Dents[index]["AW"] = Math.floor(
//             parseFloat(Dents[index]["AW"]) -
//               (parseFloat(Dents[index]["AW"]) * this.state.LAKPercentage) /
//                 100.0
//           );
//         }
//       }
//     }
//     Dents[index][key] = e.target.checked;

//     this.setState({ data });
//     this.saveChanges(data, totalDents);
//   };
//   render() {
//     const { Dents } = this.state;
//     return (
//       <>
//         <div className="container mt-50 damage-summary-section p-0">
//           <div className="row p-0">
//             <div className="col-12 damage-summary-heading p-0">
//               <h3>
//                 Damage <span> Description </span>{" "}
//               </h3>
//             </div>
//           </div>
//           <div className="row p-0 damage-summary-table">
//             <div className="col-lg-12 p-0">
//               <table
//                 width="100%"
//                 className=" table border table-responsive  w-100"
//                 border="1"
//               >
//                 <tbody>
//                   <tr width="100%">
//                     <th className="part-tr">Part</th>
//                     <th className="">{"A"}</th>
//                     <th className="">{"B"}</th>
//                     <th className="">{"C"}</th>
//                     <th className="dents-tr">Total Dents</th>
//                     <th className="aw-tr">Aw</th>
//                     <th className="alu-tr">Alu</th>
//                     <th className="lak-tr">Lak</th>
//                     <th className="replace-tr">Replace</th>
//                   </tr>
//                   {Dents &&
//                     Dents.map((row, index) => (
//                       <tr key={index}>
//                         <td>{this.lang(row.Part)}</td>

//                         <td className="" style={{ textAlign: "center" }}>
//                           {row.A}
//                         </td>
//                         <td className="" style={{ textAlign: "center" }}>
//                           {row.B}
//                         </td>

//                         <td className="" style={{ textAlign: "center" }}>
//                           {row.C}
//                         </td>
//                         <td className="" style={{ textAlign: "center" }}>
//                           {row.TotalDents}
//                         </td>
//                         <td className="" style={{ textAlign: "center" }}>
//                           {row.AW}
//                         </td>
//                         <td className="" style={{ textAlign: "center" }}>
//                           <input
//                             className="custom-control-input"
//                             type="checkbox"
//                             checked={row.Alu}
//                             onChange={(e) => {
//                               this.change(row.Part, e, index, "Alu");
//                             }}
//                             id={index + "Alu"}
//                           />
//                           <label
//                             className="custom-control-label"
//                             for={index + "Alu"}
//                           />
//                         </td>
//                         <td className="" style={{ textAlign: "center" }}>
//                           <input
//                             className="custom-control-input"
//                             type="checkbox"
//                             checked={row.Push2paint}
//                             onChange={(e) => {
//                               this.change(row.Part, e, index, "Push2paint");
//                             }}
//                             id={index + "Push2paint"}
//                           />
//                           <label
//                             className="custom-control-label"
//                             for={index + "Push2paint"}
//                           />
//                         </td>
//                         <td className="" style={{ textAlign: "center" }}>
//                           <input
//                             className="custom-control-input"
//                             type="checkbox"
//                             checked={row.Replace}
//                             onChange={(e) => {
//                               this.change(row.part, e, index, "Replace");
//                             }}
//                             id={index + "Replace"}
//                           />
//                           <label
//                             className="custom-control-label"
//                             for={index + "Replace"}
//                           />
//                         </td>
//                       </tr>
//                     ))}
//                   <tr>
//                     <td style={{ fontWeight: "bold" }}>Total</td>

//                     <td style={{ textAlign: "center", fontWeight: "bold" }}>
//                       {Dents &&
//                         Dents.reduce(
//                           (acc, num) => parseInt(acc) + parseInt(num.A),
//                           0
//                         )}
//                     </td>
//                     <td style={{ textAlign: "center", fontWeight: "bold" }}>
//                       {Dents &&
//                         Dents.reduce(
//                           (acc, num) => parseInt(acc) + parseInt(num.B),
//                           0
//                         )}
//                     </td>
//                     <td style={{ textAlign: "center", fontWeight: "bold" }}>
//                       {Dents &&
//                         Dents.reduce(
//                           (acc, num) => parseInt(acc) + parseInt(num.C),
//                           0
//                         )}
//                     </td>
//                     <td style={{ textAlign: "center", fontWeight: "bold" }}>
//                       {Dents &&
//                         Dents.reduce(
//                           (acc, num) =>
//                             parseInt(acc) + parseInt(num.TotalDents),
//                           0
//                         )}
//                     </td>
//                     <td
//                       style={{ textAlign: "center", fontWeight: "bold" }}
//                     ></td>
//                     <td
//                       style={{ textAlign: "center", fontWeight: "bold" }}
//                     ></td>
//                     <td
//                       style={{ textAlign: "center", fontWeight: "bold" }}
//                     ></td>
//                     <td
//                       style={{ textAlign: "center", fontWeight: "bold" }}
//                     ></td>
//                   </tr>
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </div>
//       </>
//     );
//   }
// }
// const mapStateToProps = (props) => {
//   return {
//     lang: props.lang,
//   };
// };
// export default connect(mapStateToProps)(RomaniaPriceTable);

import React, { Component } from "react";
import { calculatePrice } from "../../pricing/calculatePrice";
import Axios from "axios";
import { connect } from "react-redux";
import { configuration } from "../../appConfig";
import Swal from "sweetalert2";
import CarDentLogTable from "../../carbodyparts/CarDentLogTable";
import "./DNSPriceTable.css";
import "./romaniapricetable.css";
import Lightbox from "react-image-lightbox";
import { getSelectedPartnerId } from "../../redux/actions/duplicateVinPartnerId";
import { reportAuthorized } from "../../redux/actions/reportAuthorized";
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');


class RomaniaPriceTable extends Component {
  state = {
    words: {},
    lang: "En",
    data: [],
    Dents: [],
    ALUPercentage: "",
    LAKPercentage: "",
    loadedFirstTime: true,
    imageArr: [],
    imageArrDamage: [],
    currentImageIndex: 0,
    filteredImages: [],
    insuaranceProvider : {}
  };
  count = [];
  calPrice = (average, count) => {
    let pp = calculatePrice(average, count);
    //this.count.push(pp)
    return (pp * 130) / 6;
  };
  calUnit = (average, count) => {
    let pp = calculatePrice(average, count);
    this.count.push(pp);
    return pp;
  };
  avg = (ele) => {
    if (isNaN(ele) === true) {
      return 0;
    } else {
      let round = Math.round(ele / 10);
      return round * 10;
    }
  };

  getScanImages = async () => {
    const partnerId = localStorage.getItem("partnerId");
    const selectedFile = localStorage.getItem("selectedFile");
    try {
      const response = await Axios.get(configuration.getScanImages, {
        params: {
          partnerId: partnerId,
          vin: selectedFile,
        },
      });

      if (response && response.data) {
        const { data } = response;
        const filterImages = (images, keyword) => {
          return images ? images.filter(image => image.includes(keyword)) : [];
        };

        const Left = [
          ...filterImages(data.LeftFrontFender || data.Left, "LeftFrontFender"),
          ...filterImages(data.LeftFrontDoor || data.Left, "LeftFrontDoor"),
          ...filterImages(data.LeftBackDoor || data.Left, "LeftBackDoor"),
          ...filterImages(data.LeftBackFender || data.Left, "LeftBackFender")
        ];

        const right = [
          ...filterImages(data.RightFrontFender || data.right, "RightFrontFender"),
          ...filterImages(data.RightFrontDoor || data.right, "RightFrontDoor"),
          ...filterImages(data.RightBackDoor || data.right, "RightBackDoor"),
          ...filterImages(data.RightBackFender || data.right, "RightBackFender")
        ];

        this.setState({
          imageArr: [
            ...data.Hood,
            ...data.Roof,
            ...data.RightRoofFrame,
            ...data.LeftRoofFrame,
            ...data.TrunkCover,
            ...data.Trunk,
            ...right,
            ...Left,


          ],
        });
        const LeftDamage = [
          ...filterImages(data.LeftFrontFender_damage , "LeftFrontFender"),
          ...filterImages(data.LeftFrontDoor_damage , "LeftFrontDoor"),
          ...filterImages(data.LeftBackDoor_damage , "LeftBackDoor"),
          ...filterImages(data.LeftBackFender_damage , "LeftBackFender")
      ];

      const rightDamage = [
          ...filterImages(data.RightFrontFender_damage , "RightFrontFender"),
          ...filterImages(data.RightFrontDoor_damage , "RightFrontDoor"),
          ...filterImages(data.RightBackDoor_damage , "RightBackDoor"),
          ...filterImages(data.RightBackFender_damage , "RightBackFender")
      ];

        this.setState({
          imageArrDamage: [
            ...data.Hood_damage,
            ...data.Roof_damage,
            ...data.RightRoofFrame_damage,
            ...data.LeftRoofFrame_damage,
            ...data.TrunkCover_damage,
            ...data.Trunk_damage,
            ...rightDamage,
            ...LeftDamage,
            
            
          ],
        });
      }
    } catch (error) {
      console.error("Error fetching scan images:", error);
    }
  };

  getJsonApi = () => {
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    Axios.get(
      `${configuration.getData}?vin=${vin}&partnerId=${partnerId}`
    ).then((r) => {
      if (r.data) {
        this.props.reportAuthorized({
          Authorized : r.data.Authorized,
          DATReportAuthorized : r.data.DATReportAuthorized,
          MiniReportAuthorized : r.data.MiniReportAuthorized,
          FullReportAuthorized : r.data.FullReportAuthorized,
          DetailedReportAuthorized : r.data.DetailedReportAuthorized,
          AmericanReportAuthorized : r.data.AmericanReportAuthorized,
        })
        if (r.data.Client != "") {
          this.getInsurenceClients()
        }
        // try {
        //   let indexToMerge = 5;

        //   r.data.Dents[indexToMerge].AvgDiaMm +=
        //     r.data.Dents[indexToMerge + 1].AvgDiaMm;
        //   r.data.Dents[indexToMerge].A += r.data.Dents[indexToMerge + 1].A;
        //   r.data.Dents[indexToMerge].B += r.data.Dents[indexToMerge + 1].B;
        //   r.data.Dents[indexToMerge].C += r.data.Dents[indexToMerge + 1].C;
        //   r.data.Dents[indexToMerge].TotalDents +=
        //     r.data.Dents[indexToMerge + 1].TotalDents;
        //   r.data.Dents[indexToMerge].AW += r.data.Dents[indexToMerge + 1].AW;
        //   r.data.Dents[indexToMerge].AW_original +=
        //     r.data.Dents[indexToMerge + 1].AW_original;

        //   if (!r.data.Dents[indexToMerge].Alu) {
        //     r.data.Dents[indexToMerge].Alu = r.data.Dents[indexToMerge + 1].Alu;
        //   }
        //   if (!r.data.Dents[indexToMerge].Push2paint) {
        //     r.data.Dents[indexToMerge].Push2paint =
        //       r.data.Dents[indexToMerge + 1].Push2paint;
        //   }
        //   if (!r.data.Dents[indexToMerge].Replace) {
        //     r.data.Dents[indexToMerge].Replace =
        //       r.data.Dents[indexToMerge + 1].Replace;
        //   }

        //   // r.data.Dents.splice(indexToMerge + 1, 1);
        // } catch (err) {
        // }
        this.getFallbackDetails();
        this.setState({ data: r.data, Dents: r.data.Dents === undefined ? [] : r.data.Dents, Client: r.data.Client });
      }
    });
  };

  getInsurenceClients = async () => {
    const partnerId = localStorage.getItem("partnerId");

    if (partnerId) {
      const url = configuration.getInsurenceClients + "?partnerId=" + partnerId;
    const response = await Axios.post(url)
    if (response.data) {
      response.data.map((info)=>{
        if (this.state.Client && this.state.Client != undefined && this.state.Client != "" && this.state.Client.toLocaleLowerCase() &&this.state.Client.toLocaleLowerCase() == info.Name.toLocaleLowerCase()) {
          this.setState({insuaranceProvider : info})
        }
      })
      }
    }
  };

  componentDidMount() {
    this.getJsonApi();
    this.getLang();
    this.getScanImages()
    // this.getFallbackDetails();
  }

  getFallbackDetails = async () => {
    const url =
      configuration.getFallbackDetails +
      `?partner_id=${localStorage.getItem("partnerId")}`;
    const res = await Axios.get(url);

    function hexToRgb(hex) {
      if (hex === null) {
        return null;
      }

      hex = hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => '#' + r + r + g + g + b + b);
      let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : null;
    }

    let rgbColor = hexToRgb(this.state.insuaranceProvider.PrimaryColor || res.data.primary_color);
    let rgbaColor;

    if (rgbColor !== null) {
      rgbaColor = `rgba(${rgbColor.r}, ${rgbColor.g}, ${rgbColor.b}, 0.20)`;
    } else {
      rgbaColor = 'rgba(0, 0, 0, 0.20)'; // Default color
    }
    this.props.getSelectedPartnerId({
      duplicateSelectedPartnerId : res.data.vin_duplicate_partner_id.length > 0 ? res.data.vin_duplicate_partner_id : [],
      isDuplicateVin : res.data.is_vin_duplicate
    })
    this.setState({
      ALUPercentage: res.data.alu,
      LAKPercentage: res.data.lak,
      table_footer_color: res.data.table_footer_color,

      PrimaryColor: res.data.primary_color || "#FF0000",
      SecondaryColor: res.data.secondary_color || "#000000",
      PrimaryTextColor: res.data.primary_text_color || "#000000",
      SecondaryTextColor: res.data.secondary_text_color || "#fff",
      rgbaColor: rgbaColor,
    });

    if (res.data.success !== false) {
      this.setState({
        ALUPercentage: res.data.alu,
        LAKPercentage: res.data.lak,
      });
    }
  };

  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({ words: res.data, lang: localStorage.getItem("lang") });
    });
  };
  lang = (word) => {
    const { lang, words } = this.state;

    return words[word] ? words[word][lang] : word;
  };
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else if (nextProps.Authorized !== prevState.Authorized) {
      return { Authorized: nextProps.Authorized };
    } else return null;
  }
  saveChanges = (payload, totalDents) => {
    const vin = localStorage.getItem("selectedFile")
    const partnerId = localStorage.getItem("partnerId")
    Axios.get(
      `${configuration.getData}?vin=${vin}&partnerId=${partnerId}`
    ).then((r) => {
      if (r.data) {
        this.props.reportAuthorized({
          Authorized : r.data.Authorized,
          DATReportAuthorized : r.data.DATReportAuthorized,
          MiniReportAuthorized : r.data.MiniReportAuthorized,
          FullReportAuthorized : r.data.FullReportAuthorized,
          DetailedReportAuthorized : r.data.DetailedReportAuthorized,
          AmericanReportAuthorized : r.data.AmericanReportAuthorized,
        })
        payload = {
          ...payload,
          PartnerName: r.data.PartnerName,
          Color: r.data.Color,
          Comments: r.data.Comments,
          kilometerStand: r.data.kilometerStand,
          Make: r.data.Make,
          Model: r.data.Model,
          RegNo: r.data.RegNo,
          OrderNo: r.data.OrderNo,
          ScannerLocation: r.data.ScannerLocation,
          PartnerID: partnerId
        }
      }
    }).catch((err) => {
      Toast.fire({
        type: "error",
        title: "Something went wrong",
      });
    }).finally(() => {
      const { data } = this.state;
      const totalDents = this.getTotalDents();
      payload["TotalDentCount"] = totalDents;
      payload.IsPriceTableUpdated = true;
      const url =
        configuration.PostEditorChanges +
        `?partnerId=${partnerId}&vin=${vin}&dents=${totalDents}&TabViewUpdated=${!data.TabViewUpdated}`;

      Axios.post(url, payload).then((res) => {
        Toast.fire({
          type: "success",
          title: "Data saved successfully",
        });
        this.getScanImages()
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      });
    });
  };
  getTotalDents = () => {
    const { Dents } = this.state;
    let totalDents =
      Dents &&
      Dents.reduce(
        (acc, num) =>
          num.Part !== "LeftFrontTyre" && num.Part !== "LeftBackTyre" && num.Part !== "RightFrontTyre" && num.Part !== "RightBackTyre" && num.Part !== "FrontBumper" && num.Part !== "BackBumper" && num.Part !== "Underbody" && num.Part !== "Inside"
            ? parseInt(acc) + num.TotalDents
            : 0,
        0
      );
    return totalDents;
  };

  change = (part, e, index, key) => {
    const { Dents, data } = this.state;
    const totalDents = Dents[index].TotalDents;

    // if(Dents[index]['AW']){

    // if(key === 'Replace'){
    //   Dents[index]['Alu'] = false;
    //   Dents[index]['Push2paint'] = false;
    //   Dents[index][key] = e.target.checked;
    // }
    // else{
    // if(Dents[index]['Replace']){
    //   Dents[index]['Replace'] = false;
    //   Dents[index]['AW'] = Dents[index]['AW_original'] || 0;
    // }

    // }

    // }
    // else{
    //   Dents[index][key] = e.target.checked;
    //   if(key === 'Replace'){
    //     Dents[index]['Alu'] = false;
    //     Dents[index]['Push2paint'] = false;
    //     Dents[index][key] = e.target.checked;
    //     Dents[index]['AW'] = 0;
    //   }
    //   else{
    //     if(Dents[index]['Replace']){
    //       Dents[index]['Replace'] = false;
    //     }
    //   }
    // }

    // if (key === "Replace") {
    //   if (Dents[index][key]) {
    //     Dents[index]["AW"] = Dents[index]["AW_original"] || 0;
    //   } else {
    //     Dents[index]["Alu"] = false;
    //     Dents[index]["Push2paint"] = false;
    //     Dents[index]["AW"] = 0;
    //   }
    // } else {
    //   if (Dents[index]["Replace"]) {
    //     Dents[index]["Replace"] = false;
    //     Dents[index]["AW"] = Dents[index]["AW_original"] || 0;
    //   }
    //   if (!Dents[index][key]) {
    //     if (key === "Alu" && this.state.ALUPercentage) {
    //       Dents[index]["AW"] = Math.ceil(
    //         parseFloat(Dents[index]["AW"]) +
    //           (parseFloat(Dents[index]["AW"]) * this.state.ALUPercentage) /
    //             100.0
    //       );
    //     } else if (key === "Push2paint" && this.state.LAKPercentage) {
    //       Dents[index]["AW"] = Math.ceil(
    //         parseFloat(Dents[index]["AW"]) +
    //           (parseFloat(Dents[index]["AW"]) * this.state.LAKPercentage) /
    //             100.0
    //       );
    //     }
    //   } else {
    //     if (key === "Alu" && this.state.ALUPercentage) {
    //       Dents[index]["AW"] = Math.floor(
    //         parseFloat(Dents[index]["AW"]) -
    //           (parseFloat(Dents[index]["AW"]) * this.state.ALUPercentage) /
    //             100.0
    //       );
    //     } else if (key === "Push2paint" && this.state.LAKPercentage) {
    //       Dents[index]["AW"] = Math.floor(
    //         parseFloat(Dents[index]["AW"]) -
    //           (parseFloat(Dents[index]["AW"]) * this.state.LAKPercentage) /
    //             100.0
    //       );
    //     }
    //     // Dents[index]['AW'] = (parseFloat(parseFloat(Dents[index]['AW'])) - parseFloat((parseFloat(Dents[index]['AW'])/10.00))).toFixed(2);
    //   }
    // }
    if (Dents[index]["TotalDents"] > 250) {
      return;
    } else {
      Dents[index][key] = e.target.checked;
      this.setState({ data });
      // this.saveChanges(data, totalDents);
    }
  };
  // toggle = (partName, showImg, isPlastic) => {
  //   if (showImg) {
  //     const imageArr = this.state.imageArr && this.state.imageArr.length > 0 && this.state.imageArr.filter((image) => {
  //       const spiltUrl = image.split("/")[6];
  //       const part = isPlastic
  //         ? spiltUrl && spiltUrl.split("_")[0]
  //         : spiltUrl && spiltUrl.split("_")[1];
  //       return part === partName;
  //     });
  //     this.setState({
  //       modal: !this.state.modal,
  //       imgPartName: partName,
  //       currentImageIndex: 0,
  //       filteredImages: imageArr, 
  //     });
  //   } else {
  //     this.setState({
  //       modal: !this.state.modal,
  //     });
  //   }
  // };

  toggle = (partName, showImg, isPlastic) => {
    if (showImg) {
      const images = (configuration.imagePath == "https://backend.drivenscan.live" && this.props.toggleReportDamageImage) ? this.state.imageArrDamage : this.state.imageArr;
      const imageArr = images && images.length > 0 && images.filter((image) => {
        const spiltUrl = image.split("/")[(configuration.imagePath == "https://backend.drivenscan.live" && this.props.toggleReportDamageImage) ? 7 : 6];
        const reportInclude = spiltUrl && spiltUrl.includes("Report")
        const part = reportInclude ? spiltUrl && spiltUrl.split("_")[1] : spiltUrl && spiltUrl.split("_")[0];
        return part === partName;
      });
      console.log(imageArr);
      this.setState({
        modal: !this.state.modal,
        imgPartName: partName,
        currentImageIndex: 0,
        filteredImages: imageArr,
      });
    } else {
      this.setState({
        modal: !this.state.modal,
      });
    }
  };

  plasticChange = (part, e, index, key) => {
    const { name } = e.target;
    const { Dents, data } = this.state;

    if (e.target.checked) {
      data["Dents"][index]["AvgDiaMm"] = 0
      data["Dents"][index]["TotalDents"] = 0
    } else {
      data["Dents"][index]["AvgDiaMm"] = data["Dents"][index]["B"]
      data["Dents"][index]["TotalDents"] = data["Dents"][index]["A"]
    }
    data["Dents"][index][key] = e.target.checked;
    this.setState({ data }, () => {
      // this.handleSave()
    });
  };

  handleChange = (part, index, e) => {
    const { Dents, data } = this.state;
    const { name, value } = e.target;
    if (name === 'TotalDents') {
      this.setState({
        loadedFirstTime: false,
      });
      if (part == 'Trunk') {
        var indexOfTrunkCover = Dents.findIndex((dentPart) => {
          return dentPart.Part == "TrunkCover";
        });
        if (indexOfTrunkCover >= 0) {
          Dents[index][name] = Math.abs(value ? parseInt(value) : 0) + (Dents[indexOfTrunkCover]['A'] ? parseInt(Dents[indexOfTrunkCover]['A']) : 0);
          Dents[index]["A"] = Math.abs(value ? parseInt(value) : 0) + (Dents[indexOfTrunkCover]['A'] ? parseInt(Dents[indexOfTrunkCover]['A']) : 0);
          Dents[indexOfTrunkCover]['A'] = 0;
          Dents[indexOfTrunkCover][name] = 0;
        }
      }
      else {
        Dents[index][name] = Math.abs(value ? parseInt(value) : 0);
        Dents[index]["A"] = Math.abs(value ? parseInt(value) : 0);
      }

      const deviation = value - Dents[index]['OriginalDents'];
      if (deviation > 0) {
        Dents[index]['AddedCount'] = deviation;
        Dents[index]['RemovedCount'] = 0;
      } else {
        Dents[index]['RemovedCount'] = Math.abs(deviation);
        Dents[index]['AddedCount'] = 0;
      }
      if (Dents[index]["TotalDents"] > 250) {
        Dents[index]["Replace"] = true;
      } else {
        Dents[index]["Replace"] = false;
      }

    } else {
      if (part == 'Trunk') {
        var indexOfTrunkCover = Dents.findIndex((dentPart) => {
          return dentPart.Part == "TrunkCover";
        });
        if (indexOfTrunkCover >= 0) {
          Dents[index][name] = Math.abs(value ? parseInt(value) : 0) + (Dents[indexOfTrunkCover]['B'] ? parseInt(Dents[indexOfTrunkCover]['B']) : 0);
          Dents[index]["B"] = Math.abs(value ? parseInt(value) : 0) + (Dents[indexOfTrunkCover]['B'] ? parseInt(Dents[indexOfTrunkCover]['B']) : 0);
          Dents[indexOfTrunkCover]['B'] = 0;
          Dents[indexOfTrunkCover][name] = 0;
        }
      } else {
        Dents[index][name] = Math.abs(value ? parseInt(value) : 0);
        Dents[index]["B"] = Math.abs(value ? parseInt(value) : 0);
      }
    }
    this.setState({ data });
  }

  handleSave = () => {
    const { data, Dents } = this.state;
    data.Dents.forEach((part) => {
      if (part.Plastic) {
        part.TotalDamages = 0;
        part.A = 0;
        part.AvgDiaMm = 0;
        part.TotalDents = 0;
        part.B = 0;
        part.C = 0;
        part.AddedCount = 0;
        part.OriginalAw = 0;
        part.AW = 0;

        part.Alu = false;
        part.Push2paint = false;
        part.Replace = false;
      }
    });
    this.setState({ data });
    this.saveChanges(data, Dents);
  }

  render() {

    const dynamic_Table_Colors = {
      '--table-even-color': this.state.rgbaColor || '#E8F3FF',
      '--table-header-color': this.state.insuaranceProvider.PrimaryColor || this.state.PrimaryColor || '#D80707',
      '--table-footer-color': this.state.insuaranceProvider.SecondaryColor || this.state.SecondaryColor || '#000',
      '--table-header-text-color': this.state.PrimaryTextColor || '#000',
      '--table-footer-text-color': this.state.SecondaryTextColor || '#fff',
    };

    const { data, Dents, Authorized } = this.state;
    //sorting the dents table based on the given order.

    var order = [
      "Roof",
      "LeftRoofFrame",
      "RightRoofFrame",
      "Trunk",
      "TrunkCover",
      "Hood",
      "LeftFrontFender",
      "LeftFrontDoor",
      "LeftBackDoor",
      "LeftBackFender",
      "RightFrontFender",
      "RightFrontDoor",
      "RightBackDoor",
      "RightBackFender",
    ];

    Dents.sort(function (a, b) {
      // sort based on the index in order Dents
      return order.indexOf(a.Part) - order.indexOf(b.Part);
    })

    function findWithAttr(array, attr, value) {
      for (var i = 0; i < array.length; i += 1) {
        if (array[i][attr] === value) {
          return i;
        }
      }
      return -1;
    }
    let srNo = 0;

    return (
      <div className="container-fluid mt-50 damage-summary-section p-0">
        <div className="row p-0">
          <div className="col-12 damage-summary-heading p-0 d-flex justify-content-between">
            <div className='row p-0'>
              <div className='col-8 p-0'>
                <h3>{this.lang("Damage Description")} </h3>
              </div>
              <div className='col-4 text-right p-0'>
                {this.props.viewType === 'TabView' &&
                  <button
                    //  className='SubmitBut'
                    style={{
                      // padding:'5px',
                      backgroundColor: '#F20000',
                      padding: "5px 10px",
                      color: 'white',
                      border: "none",
                      borderRadius: "5px",
                      fontSize: "16px",

                    }}
                    onClick={this.handleSave}
                    disabled={Authorized}
                  >
                    {this.lang("Update Table")}
                  </button>}
              </div>
            </div>

          </div>
        </div>
        {/* <div className="row p-0 romania_price_table"> */}
        <div className={`row p-0 romania_price_table ${this.props.viewType === 'TabView' ? 'romania-main-tabview arrow_table_main_wrapper' : 'romania-main-reports-wrapper'}`}>
          <div className="col-lg-12 p-0 all-price-table-wrapper swiss_price_table_all">
            <div className="table-responsive">
              <table
                width="100%"
                className=" table w-100"
              >
                <thead>
                  <tr width="100%">
                    {/* <th className="part-tr both-top-border thead_bottom_border" width="5%"></th> */}
                    <th style={dynamic_Table_Colors} className="part-tr both-top-border thead_bottom_border" width="30%">{this.lang("Part")} </th>
                    <th className="empty_row"></th>
                    {(window.localStorage.getItem("partnerId") == "demo-ro" || window.localStorage.getItem("partnerId") == "demo-1-20") &&
                      <>
                        <th style={dynamic_Table_Colors} className="dents-tr both-top-border thead_bottom_border light-gray-col" width="10%">{this.lang("plastic")} </th>
                        <th className="empty_row"></th>
                      </>
                    }
                    <th style={dynamic_Table_Colors} className="dents-tr both-top-border thead_bottom_border orange-col" width="10%">{this.lang("Total Dents")}</th>
                    <th className="empty_row"></th>
                    {/* <th style={dynamic_Table_Colors}  className="average-size-tr both-top-border yellow-col thead_bottom_border min-width-130" width="20%">{this.lang("Average Size")} </th>
                      <th className="empty_row"></th> */}
                    {/* <th className="aw-tr" width="10%">Aw</th> */}
                    <th style={dynamic_Table_Colors} className="alu-tr both-top-border orange-col thead_bottom_border" width="10%">
                      {this.lang("Alu")}
                      {/* {this.state.ALUPercentage
                          ? `( ${parseInt(this.state.ALUPercentage)}%)`
                          : ""} */}
                    </th>
                    <th className="empty_row"></th>
                    <th style={dynamic_Table_Colors} className="lak-tr both-top-border green-col thead_bottom_border" width="10%">
                      {this.lang("Lak")}
                      {/* {this.state.LAKPercentage
                          ? `( ${parseInt(this.state.LAKPercentage)}%)`
                          : ""} */}
                    </th>
                    <th className="empty_row"></th>
                    <th style={dynamic_Table_Colors} className="replace-tr  both-top-border thead_bottom_border" width="10%">{this.lang("Replace")}</th>
                    {/* <th className="aw-tr">Aw1</th>
                      <th className="aw-tr">Aw2</th> */}
                  </tr>
                  {/* <tr width="100%" >
                          <th width="37%">Part</th>
                          <th width="10%">Total Dents</th>
                          <th width="13%">Average Size (Roundoff)</th>
                          <th width="10%">Aw</th>
                          <th width="10%">Alu</th>
                          <th width="10%">Lak</th>
                          <th width="10%">Replace</th>
                        </tr> */}
                </thead>
                <tbody className=" w-100">

                  {Dents &&
                    Dents.map((row, index) => {
                      if (row.Part !== "TrunkCover" && row.Part !== "LeftFrontTyre" && row.Part !== "LeftBackTyre" && row.Part !== "RightFrontTyre" && row.Part !== "RightBackTyre" && row.Part !== "FrontBumper" && row.Part !== "BackBumper" && row.Part !== "Underbody" && row.Part !== "Inside") {
                        srNo = srNo + 1;
                      }
                      return (
                        row.Part !== "TrunkCover" && row.Part !== "LeftFrontTyre" && row.Part !== "LeftBackTyre" && row.Part !== "RightFrontTyre" && row.Part !== "RightBackTyre" && row.Part !== "FrontBumper" && row.Part !== "BackBumper" && row.Part !== "Underbody" && row.Part !== "Inside" &&
                        <tr key={index}>
                          {/* <td className="part-tr" style={{textAlign:'center'}}>{srNo}</td> */}
                          <td style={dynamic_Table_Colors} className="part-tr">
                            <p
                              onClick={() =>
                                this.props.viewType === 'TabView' &&
                                this.toggle(row.Part, true, row.Plastic)
                              }
                            >{this.lang(row.Part)}</p></td>
                          <td className="empty_row"></td>
                          {(window.localStorage.getItem("partnerId") == "demo-ro" || window.localStorage.getItem("partnerId") == "demo-1-20") &&
                            <>
                              <td
                                style={dynamic_Table_Colors}
                                className={"price-tbody-td light-gray-col text-center"}
                              >
                                {this.props.viewType === "TabView" ? (
                                  <>
                                    <input
                                      type="checkbox"
                                      className="cross_input"
                                      checked={row.Plastic}
                                      disabled={!this.props.viewType || Authorized}
                                      onChange={(e) => {
                                        this.plasticChange(
                                          row.Part,
                                          e,
                                          index,
                                          "Plastic"
                                        );
                                      }}
                                    />
                                  </>
                                )
                                  :
                                  row.Plastic ? (
                                    <span style={{ fontSize: "16px" }}>
                                      <i className="fa fa-times"></i>
                                    </span>
                                  ) : (
                                    ""
                                  )
                                }
                              </td>
                              <td className="empty_row"></td>
                            </>
                          }
                          <td style={{ ...dynamic_Table_Colors, textAlign: "center" }} className="orange-col">
                            {/* {row.TotalDents} */}
                            {
                              (row.Part === "Trunk" && Dents[findWithAttr(Dents, 'Part', 'TrunkCover')]) ?

                                this.props.viewType === 'TabView' ?
                                  this.state.loadedFirstTime ?
                                    <div style={{ position: 'relative', width: '100%' }}>
                                      <input
                                        name='TotalDents'
                                        type='number'
                                        style={{
                                          textAlign: "center",
                                          border: "none",
                                          color: `${(row.TotalDents > 250) ? 'red' : ''}`
                                        }}
                                        onChange={(e) => !row.Plastic && this.handleChange(row.Part, index, e)}

                                        value={row.Plastic ? 0 : Dents[findWithAttr(Dents, 'Part', 'TrunkCover')].TotalDents + row.TotalDents}
                                        min='0'
                                        disabled={Authorized}
                                      />
                                      {!Authorized &&
                                        <div className="button-table-arrow-position">
                                          <button
                                            onClick={() => {
                                              const updatedValue = Math.max((parseFloat(row.Plastic ? 0 : Dents[findWithAttr(Dents, 'Part', 'TrunkCover')].TotalDents + row.TotalDents) || 0) - 1, 0);
                                              this.handleChange(row.Part, index, { target: { name: 'TotalDents', value: updatedValue } });
                                            }}
                                            className="decrement-button"
                                            disabled={Authorized}
                                          >
                                            -
                                          </button>
                                          <button
                                            onClick={() => {
                                              const updatedValue = (parseFloat(row.Plastic ? 0 : Dents[findWithAttr(Dents, 'Part', 'TrunkCover')].TotalDents + row.TotalDents) || 0) + 1;
                                              this.handleChange(row.Part, index, { target: { name: 'TotalDents', value: updatedValue } });
                                            }}
                                            className="increment-button"
                                            disabled={Authorized}
                                          >
                                            +
                                          </button>
                                        </div>
                                      }
                                    </div>
                                    :
                                    <div style={{ position: 'relative', width: '100%' }}>
                                      <input
                                        name='TotalDents'
                                        type='number'
                                        style={{
                                          textAlign: "center",
                                          border: "none",
                                          color: `${(row.TotalDents > 250) ? 'red' : ''}`
                                        }}
                                        value={row.Plastic ? 0 : row.TotalDents}
                                        min='0'
                                        disabled={Authorized}
                                        onChange={(e) => !row.Plastic && this.handleChange(row.Part, index, e)}

                                      />
                                      {!Authorized &&
                                        <div className="button-table-arrow-position">
                                          <button
                                            onClick={() => {
                                              const updatedValue = Math.max((parseFloat(row.Plastic ? 0 : row.TotalDents) || 0) - 1, 0);
                                              this.handleChange(row.Part, index, { target: { name: 'TotalDents', value: updatedValue } });
                                            }}
                                            className="decrement-button"
                                            disabled={Authorized}
                                          >
                                            -
                                          </button>
                                          <button
                                            onClick={() => {
                                              const updatedValue = (parseFloat(row.Plastic ? 0 : row.TotalDents) || 0) + 1;
                                              this.handleChange(row.Part, index, { target: { name: 'TotalDents', value: updatedValue } });
                                            }}
                                            className="increment-button"
                                            disabled={Authorized}
                                          >
                                            +
                                          </button>
                                        </div>
                                      }
                                    </div>

                                  :
                                  <p style={{ color: `${(row.TotalDents > 250) ? 'red' : ''}` }}>
                                    {Dents[findWithAttr(Dents, 'Part', 'TrunkCover')].TotalDents + row.TotalDents}
                                  </p>
                                : this.props.viewType === 'TabView' ?
                                  <div style={{ position: 'relative', width: '100%' }}>
                                    <input
                                      name='TotalDents'
                                      type='number'
                                      value={row.Plastic ? 0 : Dents[index]['TotalDents']}
                                      style={{
                                        textAlign: "center",
                                        border: "none",
                                        color: `${(row.TotalDents > 250) ? 'red' : ''}`
                                      }}
                                      min='0'
                                      onChange={(e) => !row.Plastic && this.handleChange(row.Part, index, e)}
                                      disabled={Authorized}
                                    />
                                    {!Authorized &&
                                      <div className="button-table-arrow-position">
                                        <button
                                          onClick={() => {
                                            const updatedValue = Math.max((parseFloat(row.Plastic ? 0 : Dents[index]['TotalDents']) || 0) - 1, 0);
                                            this.handleChange(row.Part, index, { target: { name: 'TotalDents', value: updatedValue } });
                                          }}
                                          className="decrement-button"
                                          disabled={Authorized}
                                        >
                                          -
                                        </button>
                                        <button
                                          onClick={() => {
                                            const updatedValue = (parseFloat(row.Plastic ? 0 : Dents[index]['TotalDents']) || 0) + 1;
                                            this.handleChange(row.Part, index, { target: { name: 'TotalDents', value: updatedValue } });
                                          }}
                                          className="increment-button"
                                          disabled={Authorized}
                                        >
                                          +
                                        </button>
                                      </div>
                                    }
                                  </div>
                                  :
                                  <p style={{ color: `${(row.TotalDents > 250) ? 'red' : ''}` }}>
                                    {Dents[index]['TotalDents']}
                                  </p>
                            }
                          </td>
                          <td className="empty_row"></td>
                          <td style={{ ...dynamic_Table_Colors, textAlign: "center" }} className="orange-col">
                            {this.props.viewType === "TabView" ? (
                              <>
                                <input
                                  className="custom-control-input"
                                  type="checkbox"
                                  checked={row.Plastic ? false : row.Alu}
                                  onChange={(e) => {
                                    !row.Plastic &&
                                      this.change(row.Part, e, index, "Alu");
                                  }}
                                  id={index + "Alu"}
                                  disabled={!this.props.viewType || Authorized}
                                />
                                <label
                                  className="custom-control-label"
                                  for={index + "Alu"}
                                />
                              </>
                            )
                              :
                              row.Alu ? (
                                <span style={{ fontSize: "16px" }}>
                                  <i className="fa fa-times"></i>
                                </span>
                              ) : (
                                ""
                              )
                            }

                          </td>
                          <td className="empty_row"></td>
                          <td style={{ ...dynamic_Table_Colors, textAlign: "center" }} className="green-col">
                            {this.props.viewType === "TabView" ? (
                              <>
                                <input
                                  className="custom-control-input"
                                  type="checkbox"
                                  checked={row.Plastic ? false : row.Push2paint}
                                  onChange={(e) => {
                                    !row.Plastic &&
                                      this.change(row.Part, e, index, "Push2paint");
                                  }}
                                  id={index + "Push2paint"}
                                  disabled={!this.props.viewType || Authorized}
                                />
                                <label
                                  className="custom-control-label"
                                  for={index + "Push2paint"}
                                />
                              </>
                            )
                              :
                              row.Push2paint ? (
                                <span style={{ fontSize: "16px" }}>
                                  <i className="fa fa-times"></i>
                                </span>
                              ) : (
                                ""
                              )
                            }
                          </td>
                          <td className="empty_row"></td>
                          <td style={{ ...dynamic_Table_Colors, textAlign: "center" }}>

                            {this.props.viewType === "TabView" ? (
                              <>
                                <input
                                  className="custom-control-input"
                                  type="checkbox"
                                  checked={row.Plastic ? false : row.Replace}
                                  onChange={(e) => {
                                    !row.Plastic &&
                                      this.change(row.part, e, index, "Replace");
                                  }}
                                  id={index + "Replace"}
                                  disabled={!this.props.viewType || Authorized}
                                />
                                <label
                                  className="custom-control-label"
                                  for={index + "Replace"}
                                />
                              </>
                            )
                              :
                              row.Replace ? (
                                <span style={{ fontSize: "16px" }}>
                                  <i className="fa fa-times"></i>
                                </span>
                              ) : (
                                ""
                              )
                            }
                          </td>
                        </tr>
                      )
                    })}

                  {!Dents.length &&
                    <tr>
                      <td colSpan={15}
                        ref={el => {
                          if (el) {
                            el.style.setProperty('text-align', 'center', 'important');
                          }
                        }}
                      >
                        {this.lang("No Data Found")}
                      </td>
                    </tr>
                  }
                </tbody>
                <tfoot>
                  <tr>
                    <td style={dynamic_Table_Colors} className="part-tr both-bottom-border"> <b> {this.lang("Total")}</b></td>
                    <td className="empty_row"></td>
                    {(window.localStorage.getItem("partnerId") == "demo-ro" || window.localStorage.getItem("partnerId") == "demo-1-20") && (
                      <>
                        <td
                          style={dynamic_Table_Colors}
                          width={"7%"}
                          // className={"both-bottom-border total-tr-table-th"}
                          className={`total-tr-table-th both-bottom-border text-center ${this.props.viewType === "TabView" ? "thead_top_border light-gray-col" : ""}`}
                        >-</td>
                        <td className="empty_row"></td>
                      </>
                    )}
                    <td style={{ ...dynamic_Table_Colors, textAlign: "center" }}
                      // className="both-bottom-border"
                      className={`both-bottom-border ${this.props.viewType === "TabView" ? "thead_top_border orange-col" : ""}`}
                    >
                      <b>
                        {Dents &&
                          Dents.reduce(
                            (acc, num) =>
                              (num.Part !== "LeftFrontTyre" && num.Part !== "LeftBackTyre" && num.Part !== "RightFrontTyre" && num.Part !== "RightBackTyre" && num.Part !== "FrontBumper" && num.Part !== "BackBumper" && num.Part !== "Underbody" && num.Part !== "Inside") ? parseInt(acc) + num.TotalDents : 0,
                            0
                          )}
                      </b>
                    </td>
                    <td className="empty_row"></td>
                    {/* <td style={{...dynamic_Table_Colors, textAlign: "center"}} 
                      className={`both-bottom-border ${this.props.viewType === "TabView" ?  "thead_top_border yellow-col" : ""}`}
                      >
                        <b>
                          {Dents &&
                            this.avg(
                              parseInt(
                                Dents.reduce((acc, num) => {
                                  return parseInt(acc) + num.AvgDiaMm;
                                }, 0) /
                                  Dents.reduce(
                                    (acc, num) =>
                                      parseInt(acc) + (num.TotalDents ? 1 : 0),
                                    0
                                  )
                              )
                            )}
                        </b>
                      </td>
                      <td className="empty_row"></td> */}
                    <td style={dynamic_Table_Colors}
                      className={`both-bottom-border ${this.props.viewType === "TabView" ? "thead_top_border orange-col" : ""}`}
                    >-</td>
                    <td className="empty_row"></td>
                    <td style={dynamic_Table_Colors}
                      className={`both-bottom-border ${this.props.viewType === "TabView" ? "thead_top_border green-col" : ""}`}
                    >-</td>
                    <td className="empty_row"></td>
                    <td style={dynamic_Table_Colors} className="both-bottom-border">-</td>
                  </tr>
                </tfoot>
              </table>
              {this.state.modal && (
                <Lightbox
                  reactModalStyle={{
                    overlay: { zIndex: 100000000 },
                    content: {},
                  }}
                  mainSrc={
                    this.state.filteredImages.length > 0
                      ? `${this.state.filteredImages[this.state.currentImageIndex]}?t=${new Date().getTime()}` // Append timestamp
                      : require("../../assets/img/brand/dashboard-error-logo.png")
                  }
                  imageCaption={this.state.filteredImages.length > 0 && this.lang(
                    this.state.filteredImages[this.state.currentImageIndex]
                      .split('/')
                      .pop()
                      .replace(/^Report_/, '')
                      .replace(/_\d+\.jpg$/, '')
                  )}
                  nextSrc={
                    `${this.state.filteredImages[
                      (this.state.currentImageIndex + 1) % this.state.filteredImages.length
                    ]}?t=${new Date().getTime()}`
                  }
                  prevSrc={
                    `${this.state.filteredImages[
                      (this.state.currentImageIndex +
                        this.state.filteredImages.length -
                        1) % this.state.filteredImages.length
                    ]}?t=${new Date().getTime()}`
                  }
                  onCloseRequest={() => this.setState({ modal: false })}
                  onMovePrevRequest={() =>
                    this.setState({
                      currentImageIndex:
                        (this.state.currentImageIndex +
                          this.state.filteredImages.length -
                          1) %
                        this.state.filteredImages.length,
                    })
                  }
                  onMoveNextRequest={() =>
                    this.setState({
                      currentImageIndex:
                        (this.state.currentImageIndex + 1) %
                        this.state.filteredImages.length,
                    })
                  }
                  onImageLoadError={(...events) => console.log(events)}
                  imageLoadErrorMessage={
                    <img
                      style={{ height: "100%", width: "100%" }}
                      src={require("../../assets/img/brand/dashboard-error-logo.png")}
                    />
                  }
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapDispatchtoProps = (dispatch) => {
  return {
    getSelectedPartnerId: (show) => dispatch(getSelectedPartnerId(show)),
    reportAuthorized: (show) => dispatch(reportAuthorized(show)),
  };
};
const mapStateToProps = (props) => {
  return {
    lang: props.lang,
    toggleReportDamageImage : props.toggleReportDamageImage
  };
};
export default connect(mapStateToProps,mapDispatchtoProps)(RomaniaPriceTable);
